import Tools from "../../../base/components/tools";
import loadCopys from "../../../base/services/consorcio.i18n";
import Services from "../../../base/services/services";
import Mensajes from "../../../base/components/mensajes";
import OpcionesValidacionInicial from "./components/opcionesValidacionInicial";
import FormularioInformacionCaso from "./components/formularioInformacionCaso";

import "../index.less";

class InformacionCasoAsegurabilidad extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configurations: {},
      authenticatedUser: {},
      isAuthenticatedBoolean: false,
      isAsesor: false,
      radicado: this.getUrlParameter().radicado,
      isInitialValidation: JSON.parse(this.getUrlParameter().validacionInicial),
      isAfilliateViability: JSON.parse(this.getUrlParameter().esViabilidadAfiliados),
      showError: false,
      form: {
        asesorName: "",
        viabilitySentDate: "",
        expirationDate: "",
        billNumber: "",
        processState: "",
        participants: 0,
        viabilityDocument: {
          documentName: "",
          documentUrl: ""
        },
        contractor: {
          identification: {
            typeId: 0,
            type: "",
            number: ""
          },
          name: { value: "" }
        },
        subscribed: {
          viabilitySubscribed: [],
          riskySubscribed: []
        },
        initialValidationOption: {
          id: 0,
          value: ""
        },
        complexity: {
          id: 0,
          value: ""
        },
        supportProffesional: {
          id: 0,
          value: ""
        },
        observaciones: {
          id: 0,
          value: ""
        },
        viabilityObservaciones: {
          id: 0,
          value: ""
        },
        viabilityAnswer: {
          value: ''
        }
      },
      initialValidationOptionsList: [
        {
          id: 1,
          text: "Asignar a Profesional Centro de Apoyo"
        },
        {
          id: 2,
          text: "Devolver a Asesor"
        }
      ],
      complexityList: [
        {
          id: 1,
          text: "Normal"
        },
        {
          id: 2,
          text: "Alta"
        }
      ],
      supportProffesionalsList: [
      ],
      observacionesList: [
      ],
      showError: false,
      infoIsValid: false
    };

    this.pnpService = new ServicioPnp();
    this.service = new Services();
    this.tools = new Tools();

    this.getIdentificationUserData = this.getIdentificationUserData.bind(this);
    this.handleSwitchSelect = this.handleSwitchSelect.bind(this);
    this.handleTextInputChange = this.handleTextInputChange.bind(this);
    this.sendData = this.sendData.bind(this);
    this.redirectAfilliate = this.redirectAfilliate.bind(this);

    loadCopys("cicloVentaAfiliacion/informacionDelCasoAsegurabilidad/text.js");
  }
  handleSwitchSelect(value, field) {
    const form = { ...this.state.form };

    if(field === 'complexity') {
      form.supportProffesional = {
        id: 0,
        value: ''
      }
      let serviceUrl = '';
      if(value === 'Normal') {
        serviceUrl = 'ListadoProfesionalesCentroApoyoNormal';
      } else if(value === 'Alta') {
        serviceUrl = 'ListadoProfesionalesCentroApoyoAlta';
      }

      const proffesionalsService = new ServicioProxy(serviceUrl, 'ServicioFlujos.svc');

      proffesionalsService.getElements('POST', {})
        .then(response => {
          const data = JSON.parse(response);

          const professionals = data.Losprofesionales;
          const supportProffesionalsList = professionals.map(professional => {
            return {
              id: professional.CorreoProfesional,
              name: professional.NombreProfesional
            }
          })
          this.setState({supportProffesionalsList});
        })
        .catch(error => {
          this.setState({ showError: true });
          setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
        })
    }
    form[field].value = value;
    const infoIsValid = this.checkInfo(form);

    this.setState({ form, infoIsValid });
  }
  handleTextInputChange(e, field) {
    e.preventDefault();

    const form = { ...this.state.form };

    form[field].value = e.target.value;
    const infoIsValid = this.checkInfo(form);

    this.setState({ form, infoIsValid });
  }
  componentDidMount() {
    const configurations = {};

    this.pnpService.getListWithTop("configuraciones", list => {
      list.forEach(item => {
        configurations[item.CSNombreText] = item.CSValorNote;
      });
      this.setState({ configurations: configurations });
    }, 200, null, 'CSNombreText', 'CSValorNote');

    this.pnpService.getListWithTop("parametrosPaginas", list => {
      list.forEach(item => {
        if(item.CSNombreText === 'ObservacionesAsegurabilidad') {
          const data = item.CSValorNote.split('\n');

          const observacionesList = data.map((element, index) => {
            return {
              id: index + 1,
              text: element
            }
          })

          this.setState({observacionesList});
        }
        configurations[item.CSNombreText] = item.CSValorNote;
        configurations[item.CSNombreText + "CSVisibleBool"] =
          item.CSVisibleBool;
      });
      this.setState({ configurations: configurations });
    }, 200, "CSFormularioChoice eq 'Venta Vinculaci%C3%B3n'", 'CSDescripcionNote', 'CSFormularioChoice', 'CSNombreText', 'CSValorNote', 'CSVisibleBool');

    this.pnpService.getList("tiposDocumento", typeDocList => {
      this.setState({ typeDocList });
    }, null, "CSIdDocumentoText", "CSSiglaText", "CSDocumentoIdentidadText");

    if(this.state.isInitialValidation) {
      const profesionalesService =new ServicioProxy('ListadoProfesionalesCentroApoyo', 'ServicioFlujos.svc');

      profesionalesService.getElements('POST', {})
        .then(response => {
          const data =JSON.parse(response);

          const professionals = data.Losprofesionales;
          const supportProffesionalsList = professionals.map(professional => {
            return {
              id: professional.CorreoProfesional,
              name: professional.NombreProfesional
            }
          })
          this.setState({supportProffesionalsList});
        })
        .catch(error => {
          this.setState({ showError: true });
          setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
        })
    }

    setTimeout(() => {
      this.tools.isAsesor()
        .then(isAsesor => {
          const asesor = JSON.parse(isAsesor);
          this.setState({ isAsesor: asesor });

          //if(this.tools.isAuthenticated()) {
          const authenticatedUser = compTools.obtenerInformacionUsuario();
          if(asesor) {
            this.getIdentificationUserData();
          } else {
            //this.getAffiliates(authenticatedUser);
            this.setState({ authenticatedUser });
          }

          // }

          this.getFormInfo();
        })
        .catch(error => console.log(error));
    }, 500);
  }

  
  getUrlParameter() {
    var vars = {};
    var parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function(m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  }

  getIdentificationUserData() {
    this.service.getIdentificationUserData(this.state.radicado)
      .then(data => {
        const authenticatedUser = this.state.authenticatedUser;
        authenticatedUser["LegalID"] = data["NumeroIdentificacion"];
        authenticatedUser["TipoIdentificacion"] = data["TipoDeIdentificacion"]["IdDocumento"];
        this.setState({ authenticatedUser });
      })
      .catch(error => {
        if (error["Error"] !== null) {
          this.setState({ showError: true });
        }
      });
  }
  getFormInfo() {
    const viabilityCaseService = new ServicioProxy(`InfoRespuestaAsegurabilidad?numeroRadicado=${this.state.radicado}`,"ServicioFlujos.svc");
    const form = { ...this.state.form };

/*     form.subscribed.viabilitySubscribed.push(this.fillUserInfo({
      TipoDocumentoIdentificacion: {
        Sigla: "CC",
        IdDocumento: "1"
      },
      NumeroIdentificacion: "1234",
      NombreCompleto: "Afiliado 1",
      AfiliadoViable: true
    })); */

    viabilityCaseService.getElements("POST", {})
      .then(response => {
        const data = JSON.parse(response);
        //data.Error = 'algoPaso';
        if(!data.Error) {
          form.asesorName = data.NombreAsesor.split("#")[1];
          form.viabilitySentDate = data.FechaEnvioAsegurabilidadstr;
          form.expirationDate = data.FechaVencimientostr;
          form.billNumber = data.NumeroFactura;
          form.processState = data.Estado;
          form.participants = data.Integrantes;
          form.viabilityDocument.documentName = data.DeclaracionAsegurabilidad ? data.DeclaracionAsegurabilidad.NombreDocumento : "";
          form.viabilityDocument.documentUrl = data.DeclaracionAsegurabilidad ? data.DeclaracionAsegurabilidad.UrlDocumento : "";
          form.contractor = this.fillUserInfo(data.Contratante);

          if(data.AfiliadosAsegurabilidad) {
            data.AfiliadosAsegurabilidad.forEach(afiliado => {
              form.subscribed.viabilitySubscribed.push(this.fillUserInfo(afiliado, true));
            });
          }

          if(data.AfiliadosRiesgos) {
            data.AfiliadosRiesgos.forEach(afiliado => {
              form.subscribed.riskySubscribed.push(this.fillUserInfo(afiliado, true));
            });
          }

          this.setState({ form });
        } else {
          this.setState({ showError: true });
          setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
        }
      })
      .catch(error => {
        console.log("------------------------------------");
        console.log(error);
        console.log("------------------------------------");

        this.setState({ showError: true });
        setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
      });
  }
  fillUserInfo(userData, isAfiliado = false) {
    const filledUserData = {
      identification: {
        typeId: isAfiliado ? userData.TipoIdentificacion : userData.TipoDocumentoIdentificacion.IdDocumento ,
        type: isAfiliado ? userData.TipoIdentificacionSigla : userData.TipoDocumentoIdentificacion.Sigla,
        number: userData.NumeroIdentificacion
      },
      name: { value: userData.NombreCompleto },
      isViable: userData.AfiliadoViable === "No" ? false : true
    };

    return filledUserData;
  }
  getPopover(key) {
    return (
      <Popover title="">
        <div dangerouslySetInnerHTML={{ __html: this.state.configurations[key] }} />
      </Popover>
    );
  }
  renderGeneralErrorModal() {
    return <Mensajes ref="generalErrorModal" showModal={true} msg={""} />;
  }

  sendData(e, type) {
    e.preventDefault();

    const form = {...this.state.form};

    const sendDataService = new ServicioProxy(`AsignarPCAoDevolverAsesor?numeroRadicado=${this.state.radicado}`, 'ServicioFlujos.svc');

    sendDataService.getElements('POST', {
      ResultadoValidacionInicial: type,
      Complejidad: form.complexity.value,
      ProfesionalCentroApoyo: form.supportProffesional.value,
      Observaciones: form.observaciones.value,
      ObservacionesAsegurabilidad: form.viabilityObservaciones.value
    })
      .then(response => {
        const data = JSON.parse(response);

        if(data) {
          //redireccion
          if(this.state.isInitialValidation) {
            window.location.href = _spPageContextInfo.webAbsoluteUrl + this.state.configurations['UrlListadoAfiliacionesAuxAsesgurabilidad'];
          }
        } else {
          this.setState({ showError: true });
          setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
        }
      })
      .catch(error => {
        this.setState({ showError: true });
        setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
      })
  }
  sendResults(e) {
    e.preventDefault();

    const form = {...this.state.form};

    const sendResultsService = new ServicioProxy(`RespuestaAsegurabilidadDefinirViabilidad?numeroRadicado=${this.state.radicado}&Respuesta=${form.viabilityAnswer.value}`, 'ServicioFlujos.svc');

    sendResultsService.getElements('POST', {})
      .then(response => {
        const data = JSON.parse(response);

        if(data) {
          const sendResultService = new ServicioProxy(`EnviarResultado?numeroRadicado=${this.state.radicado}`, 'ServicioFlujos.svc');

          sendResultService.getElements('POST', {})
            .then(_response => {
              const _data = JSON.parse(_response);

              if(this.state.isAfilliateViability) {
                window.location.href = _spPageContextInfo.webAbsoluteUrl + this.state.configurations['UrlListadoAfiliacionesPCA'];
              }
            })
            .catch(_error => {
              this.setState({ showError: true });
              setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
            })
        } else {
          this.setState({ showError: true });
          setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
        }
      })
      .catch(error => {
        this.setState({ showError: true });
        setTimeout(() => this.refs.generalErrorModal.handleShow(), 0);
      })
  }
  redirectAfilliate(e, afilliate) {
    e.preventDefault();

    window.location.href = `${_spPageContextInfo.webAbsoluteUrl}${this.state.configurations["UrlViabilidadInformacionAfiliado"]}?tipoIdentificacion=${afilliate.identification.typeId}&numeroIdentificacion=${afilliate.identification.number}&esDefinicionViabilidad=${true}&radicado=${this.state.radicado}`

  }

  checkInfo(form) {
    const isAfilliateViability = this.state.isAfilliateViability;
    const isInitialValidation = this.state.isInitialValidation;

    let isValid = true; 

    if(isInitialValidation) {

      if(!form.initialValidationOption.value) {
        isValid = false;
      }

      if(!form.observaciones.value) {
        isValid = false;
      }

      if(form.initialValidationOption.value === 'Asignar a Profesional Centro de Apoyo') {
        if(!form.complexity.value) {
          isValid = false;
        }
        if(!form.complexity.value) {
          isValid = false; 
        }
        if(!form.supportProffesional.value) {
          isValid = false;
        }
      }
      
    } else if(isAfilliateViability) {
      if(form.subscribed.viabilitySubscribed.length) {
        form.subscribed.viabilitySubscribed.forEach(item => {
          if(item.isViable === null) {
            isValid = false;
          }
        })
      }
      if(form.subscribed.riskySubscribed.length) {
        form.subscribed.riskySubscribed.forEach(item => {
          if(item.isViable === null) {
            isValid = false;
          }
        })
      }

      if(!form.viabilityAnswer.value) {
        isValid = false; 
      }
    }
    return isValid; 
  }

  goBack(e) {
    e.preventDefault();
    const url = this.getUrlParameter().UrlRetorno
    console.log(this.getUrlParameter());
    window.location.href = url;
  /*   if(this.state.isInitialValidation) {
      window.location.href = _spPageContextInfo.webAbsoluteUrl + this.state.configurations['UrlListadoAfiliacionesAuxAsesgurabilidad'];
    } else {
      window.location.href = _spPageContextInfo.webAbsoluteUrl + this.state.configurations['UrlListadoAfiliacionesPCA'];
    } */
  }

  render() {
    const isPCA = this.state.form.initialValidationOption.value === "Asignar a Profesional Centro de Apoyo";
    return (
      <div className="process-info-viability-container">
        {this.state.showError && this.renderGeneralErrorModal()}
        <div className="viability-container">
          <FormularioInformacionCaso
            radicado={this.state.radicado}
            form={this.state.form}
            configurations={this.state.configurations}
            isInitialValidation={this.state.isInitialValidation}
            isAfilliateViability={this.state.isAfilliateViability}
          />
          {this.state.isInitialValidation && !this.state.isAfilliateViability && (
            <OpcionesValidacionInicial
              initialValidationOptionsList={this.state.initialValidationOptionsList}
              complexityList={this.state.complexityList}
              supportProffesionalsList={this.state.supportProffesionalsList}
              observacionesList={this.state.observacionesList}
              form={this.state.form}
              handleSwitchSelect={this.handleSwitchSelect}
              handleTextInputChange={this.handleTextInputChange}
            />
          )}
          {this.state.isInitialValidation && !this.state.isAfilliateViability && (
            <div className="viability-options-section">
              <button className="btn btn-default" onClick={this.goBack.bind(this)}>
                {i18next.t("regresar")}
              </button>
              {!isPCA && (
                this.state.infoIsValid ? (
                  <button className="btn btn-default" onClick={(e) => this.sendData(e, 0)}>
                    {i18next.t("devolverAsesor")}
                  </button>
                ) : (
                  <OverlayTrigger placement={'top'} overlay={this.getPopover('TooltipContinuarPaso4')}>
                    <div style={{display: 'inline-block'}}><button disabled  style={{pointerEvents: 'none'}} className="btn btn-disabled">{i18next.t('devolverAsesor')}</button></div>
                  </OverlayTrigger>
                )
              )}
              {isPCA && (
                this.state.infoIsValid ? (
                  <button className="btn btn-default" onClick={(e) => this.sendData(e, 1)}>
                    {i18next.t("asignarPCA")}
                  </button>
                ) : (
                  <OverlayTrigger placement={'top'} overlay={this.getPopover('TooltipContinuarPaso4')}>
                    <div style={{display: 'inline-block'}}><button disabled  style={{pointerEvents: 'none'}} className="btn btn-disabled">{i18next.t('asignarPCA')}</button></div>
                  </OverlayTrigger>
                )
              )}
            </div>
          )}
          {!this.state.isInitialValidation && this.state.isAfilliateViability && (
            <form className="form-horizontal">
              <h2>{i18next.t('viabilidadAfiliados')}</h2>
              {this.state.form.subscribed.viabilitySubscribed.length > 0 && <p>{i18next.t('afiliadosCondiciones')}</p>}
              {this.state.form.subscribed.viabilitySubscribed.length > 0 && <table className="subscribed-table">
                <thead>
                  <tr>
                    <th>{i18next.t('nombre')}</th>
                    <th>{i18next.t('tipoDocumentoSigla')}</th>
                    <th>{i18next.t('documento')}</th>
                    <th>{i18next.t('viablePregunta')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.form.subscribed.viabilitySubscribed.map(subscribed => {
                    return (
                      <tr onClick={(e) => this.redirectAfilliate(e, subscribed)}>
                        <td>{subscribed.name.value}</td>
                        <td>{subscribed.identification.type}</td>
                        <td>{subscribed.identification.number}</td>
                        <td>{subscribed.isViable ? i18next.t('si') : subscribed.isViable === null ? '' : i18next.t('no')}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>}
              {this.state.form.subscribed.riskySubscribed.length > 0 && <p>{i18next.t('afiliadosRiesgosuDiagnosticos')}</p>}
              {this.state.form.subscribed.riskySubscribed.length > 0 && <table className="subscribed-table">
                <thead>
                  <tr>
                    <th>{i18next.t('nombre')}</th>
                    <th>{i18next.t('tipoDocumentoSigla')}</th>
                    <th>{i18next.t('documento')}</th>
                    <th>{i18next.t('viablePregunta')}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.form.subscribed.riskySubscribed.map(subscribed => {
                    return (
                      <tr onClick={(e) => this.redirectAfilliate(e, subscribed)}>
                        <td>{subscribed.name.value}</td>
                        <td>{subscribed.identification.type}</td>
                        <td>{subscribed.identification.number}</td>
                        <td>{subscribed.isViable ? i18next.t('si') : subscribed.isViable === null ? '' : i18next.t('no')}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>}
              <div className="form-group">
                <label className="col-sm-3 control-label">
                  {i18next.t('respuestaAsegurabilidad')}
                </label>
                <div className="col-sm-9">
                  <input type="text" id="viabilityAnswer" className="form-control" value={this.state.form.viabilityAnswer.value} onChange={(e) => this.handleTextInputChange(e, 'viabilityAnswer')} />
                </div>
              </div>
              <div className="viability-options-section" onClick={this.goBack.bind(this)}>
                <button className="btn btn-default">
                  {i18next.t("regresar")}
                </button>
                {
                    this.state.infoIsValid ? (
                      <button className="btn btn-default" onClick={this.sendResults.bind(this)}>
                        {i18next.t("enviarResultados")}
                      </button>
                    ) : (
                      <OverlayTrigger placement={'top'} overlay={this.getPopover('TooltipContinuarPaso4')}>
                        <div style={{display: 'inline-block'}}><button disabled  style={{pointerEvents: 'none'}} className="btn btn-disabled">{i18next.t('enviarResultados')}</button></div>
                      </OverlayTrigger>    
                    )
                  }
              </div>
            </form>
          )}
        </div>
      </div>
    );
  }
}

const Popover = ReactBootstrap.Popover;
const MenuItem = ReactBootstrap.MenuItem;
const DropdownButton = ReactBootstrap.DropdownButton;
const Button = ReactBootstrap.Button;
const OverlayTrigger = ReactBootstrap.OverlayTrigger;

const appId = document.getElementById("informacion-caso-viabilidad");
ReactDOM.render(<InformacionCasoAsegurabilidad />, appId);



// WEBPACK FOOTER //
// ./cicloVentaAfiliacion/informacionDelCasoAsegurabilidad/src/index.js